export enum SPACING {
  X_SMALL = "4px",
  SMALL = "8px",
  MEDIUM = "16px",
  LARGE = "24px",
  X_LARGE = "32px",
  XXX_LARGE = "120px",
}

export const STACKED = Object.freeze({
  X_SMALL: `margin-bottom: ${SPACING.X_SMALL}`,
  SMALL: `margin-bottom: ${SPACING.SMALL}`,
  MEDIUM: `margin-bottom: ${SPACING.MEDIUM}`,
  LARGE: `margin-bottom: ${SPACING.LARGE}`,
  X_LARGE: `margin-bottom: ${SPACING.X_LARGE}`,
  XXX_LARGE: `margin-bottom: ${SPACING.XXX_LARGE}`,
});

export const COLOR_PRIMARY_600 = "#017989";
export const COLOR_NEUTRAL_500 = "#aeadac";
